export function isVerticalFirstLetter(origin: string[][], x: number, y: number): boolean {
  return !origin[y - 1]?.[x] && !!origin[y + 1]?.[x] && !!origin[y][x]
}